/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import Cookies from "./cookies"
//import "./base.css"
import "./bootstrap.min.css"
import "./theme.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div className="main-app-wrap">
      <Header siteTitle={data.site.siteMetadata.title}></Header>
      <link
        rel="stylesheet"
        href="/icon.css"
        integrity=""
        crossOrigin="anonymous"
      />
      <div className="app-layout">
        <main>{children}</main>
        <div className="footer-layout">
          <Footer />
          {/* <Cookies /> */}
        </div>
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
